import api from '../lib/api';

export const VEHICLE_ZONES_LOADING = 'VEHICLE_ZONES_LOADING';
export const FETCH_VEHICLE_ZONES = 'FETCH_VEHICLE_ZONES';
export const CREATE_VEHICLE_ZONE = 'CREATE_VEHICLE_ZONE';
export const UPDATE_VEHICLE_ZONE = 'UPDATE_VEHICLE_ZONE';
export const DELETE_VEHICLE_ZONE = 'DELETE_VEHICLE_ZONE';

function createVehicleZone(args) {
  return (dispatch) => api.createVehicleZone(args)
    .then((data) => {
      dispatch({ type: CREATE_VEHICLE_ZONE, payload: data });
      return data;
    });
}

function updateVehicleZone(id, updateObj) {
  return (dispatch) => api.updateVehicleZone(id, updateObj)
    .then((data) => {
      dispatch({ type: UPDATE_VEHICLE_ZONE, payload: data });
      return data;
    });
}

function deleteVehicleZone(id) {
  return (dispatch) => api.deleteVehicleZone(id)
    .then((response) => response.data)
    .then((data) => {
      dispatch({ type: DELETE_VEHICLE_ZONE, payload: data });
      return data;
    });
}

function fetchVehicleZones(marketId) {
  return (dispatch) => {
    dispatch({ type: VEHICLE_ZONES_LOADING, payload: true });

    return api.getVehicleZones({ market_id: marketId })
      .then((data) => {
        dispatch({ type: FETCH_VEHICLE_ZONES, payload: data });
        return data;
      })
      .then((data) => {
        dispatch({ type: VEHICLE_ZONES_LOADING, payload: false });
        return data;
      })
      .catch((data) => {
        dispatch({ type: VEHICLE_ZONES_LOADING, payload: false });
        return data;
      });
  };
}

export default {
  fetchVehicleZones,
  updateVehicleZone,
  createVehicleZone,
  deleteVehicleZone,
};
